import React from "react"

function CardTeam({ person }) {
  return (
    <div
      className="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2"
      uk-grid="true"
    >
      <div
        className="uk-background-cover uk-card-media-left"
        style={{
          backgroundImage: `url(${person.image})`
        }}
      ></div>
      <div className="uk-width-expand">
        <div className="uk-card-body">
          <h3 className="uk-card-title">{person.name}</h3>
          <h5 className="uk-margin-small-top font-red">{person.position}</h5>
          <p className="uk-text-secondary uk-text-small">
            {person.description}
          </p>
        </div>
      </div>
    </div>
  )
}

export default CardTeam
